<template>
		<section class="section clearfix" data-stellar-background-ratio="0.4">
			<div class="container">
				<div class="row">
					<div class="col-md-12 align-center">
						<i class="fa fa-tree fa-3x mar-bot20 notransition animated fadeInLeftNow animation103"></i>
						<p class="section-header notransition animated fadeInDownNow animation103">研究方向</p>
					</div>
				</div>
				<div class="row mar-bot40 mar-top40">
					<div class="col-md-4 align-center notransition animated fadeInDownNow animation53">
						<!--<i class="fa fa-circle-o fa-3x mar-bot20"></i>-->
						<img src="../assets/img/interest/jiqi.jpg" draggable="false" class="img-responsive center-block" style="border-radius: 50%;width:250px;border: #e6e6e6 5px solid;">
						<h3 class="text-bold mar-top20">机器学习</h3>
						<p class="mar-bot20">你只管休息，剩下的交给机器学习
						</p>
					</div>
					<div class="col-md-4 align-center notransition animated fadeInDownNow animation56">
						<!--<i class="fa fa-circle-o fa-3x mar-bot20"></i>-->
						<img src="../assets/img/interest/houduan.jpg" draggable="false" class="img-responsive center-block" style="border-radius: 50%;width:250px;border: #e6e6e6 5px solid;">
						<h3 class="text-bold mar-top20">后端开发</h3>
					<p class="mar-bot20">不可能注释的，这辈子是不可能注释的
						</p>
					</div>
					<div class="col-md-4 align-center notransition animated fadeInDownNow animation59">
						<!--<i class="fa fa-circle-o fa-3x mar-bot20"></i>-->
						<img src="../assets/img/interest/qianduan.jpg" draggable="false" class="img-responsive center-block" style="border-radius: 50%;width:250px;border: #e6e6e6 5px solid;">
						<h3 class="text-bold mar-top20">前端开发</h3>
					<p class="mar-bot20">需求又改了，你有本事再说一遍
						</p>
					</div>
					<div class="col-md-12 align-center notransition animated fadeInDownNow animation53 mar-top40">
						<p class="section-subheader">梦想是一定要有的，万一实现了呢</p>
					</div>
					<div class="col-md-12 maintext notransition animated fadeInUpNow animation103">
						<p>
							<strong>姬霄</strong> 我们都是突然长大。那个瞬间，在无可挽回的事实前，学会了从容不迫；在大势所趋时，学会了不动声色。开始保守地给予，迅速地放弃，游刃有余地周旋。在那些众口一辞的节日里，将最好的情感夹杂在寻常祝福中，试图蒙蔽隐秘的初衷。
						</p>
						<!-- <p>
							<strong>王尔德</strong> 在我年轻的时候，曾以为金钱是世界上最重要的东西。现在我老了，才知道，的确如此。
						</p> -->
						<p>
							<strong>芥川龙之介</strong> 最聪明的处世术是，既对世俗投以白眼，又与其同流合污。
						</p>
						<p>
							<strong>张瑞琪</strong> 很久以后我才明白，想让你记住我，并不是需要在告别的时候大声念三遍我的名字，而是拼命向上与你等高，让你一侧过头一转过身就会知道，我是谁。
						</p>
					</div>
				</div>

			</div>
		</section>
</template>

<style>

</style>

<script>
export default {
  name: 'InterestContent'
}
</script>